import { UserType } from '../constants/userTypes';

const USER_SESSION_KEY = 'UserSession';

const UserInfo = {
  userID: '',
  fullName: '',
  email: '',
  userType: '',
  userProfileImg: '',
  isSubscriber: false,
  products: [],
  subscriptionEndDate: '',
  companyName: '',
  activationPlan: '',
  productCode: '',
  showRenewal: false,
  companyId: '',
  isDefaultPassword: false,
};

const UserSessionManager = {
  setSession(userData) {
    if (!userData) return;
    const existing = this.getSession() || {};
    const sessionData = {
      businessAdminId: userData.businessAdminId ?? existing.businessAdminId,
      fullName: userData.fullName ?? existing.fullName,
      email: userData.email ?? userData.Email ?? existing.email,
      userType: userData.userType ?? existing.userType,
      userProfileImg: userData.userProfileImg ?? existing.userProfileImg,
      isSubscriber: userData.isSubscriber ?? existing.isSubscriber,
      products: userData.products ?? existing.products ?? [],
      subscriptionEndDate: userData.subscriptionEndDate ?? existing.subscriptionEndDate,
      companyName: userData.companyName ?? existing.companyName,
      activationPlan: userData.activationPlan ?? existing.activationPlan,
      productCode: userData.productCode ?? existing.productCode,
      showRenewal: userData.showRenewal ?? existing.showRenewal,
      companyId: userData.companyId ?? existing.companyId,
      isDefaultPassword:
        userData.isDefaultPassword ??
        userData.IsDefaultPassword ??
        existing.isDefaultPassword ??
        false,
    };
    localStorage.setItem(USER_SESSION_KEY, JSON.stringify(sessionData));
  },

  getSession() {
    const data = localStorage.getItem(USER_SESSION_KEY);
    console.log('UserSessionManager.getSession()', JSON.parse(data));
    return data ? JSON.parse(data) : null;
  },

  getUserInfo() {
    const data = this.getSession();
    if (!data) return null;
    
    // Create and return a UserInfo object
    return {
      userID: data.userID || '',
      fullName: data.fullName || '',
      email: data.email || '',
      userType: data.userType || '',
      userProfileImg: data.userProfileImg || '',
      isSubscriber: data.isSubscriber || false,
      products: data.products || [],
      subscriptionEndDate: data.subscriptionEndDate || '',
      companyName: data.companyName || '',
      activationPlan: data.activationPlan || '',
      productCode: data.productCode || '',
      showRenewal: data.showRenewal || false,
      companyId: data.companyId || '',
      isDefaultPassword: Boolean(data.isDefaultPassword),
    };
  },

  requiresPasswordChange() {
    const data = this.getSession();
    return Boolean(data?.isDefaultPassword);
  },

  updateSession(partialData) {
    if (!partialData) return;
    const existing = this.getSession() || {};
    this.setSession({ ...existing, ...partialData });
  },

  isAdmin() {
    const data = this.getSession();
    return data?.userType?.toLowerCase().includes(UserType.ADMIN) ?? false;
  },

  isSuperAdmin() {
    const data = this.getSession();
    return data?.userType?.toLowerCase() === UserType.SUPER_ADMIN;
  },

  isDeveloper() {
    const data = this.getSession();
    if (!data) return false;
    const type = data.userType;
    if (Number(type) === 4) return true;
    return String(type ?? "").toLowerCase().includes(UserType.DEVELOPER);
  },

  updateShowRenewal(value) {
    const data = this.getSession();
    if (!data) return;
    data.showRenewal = Boolean(value);
    localStorage.setItem(USER_SESSION_KEY, JSON.stringify(data));
  },

  clearSession() {
    localStorage.removeItem(USER_SESSION_KEY);
  },
};

export default UserSessionManager;